/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockErrorGoodsProcessVo
 */
export interface StockErrorGoodsProcessVo {
    /**
     * 商品检查单ID集合
     * @type {Array<number>}
     * @memberof StockErrorGoodsProcessVo
     */
    checkOrderIds?: Array<number>;
    /**
     * 处理分组，提交的时候前端给个随机的组号
     * @type {number}
     * @memberof StockErrorGoodsProcessVo
     */
    processGroup?: number;
    /**
     * 处理方式 1 废弃, 2 退货, 3 无视错误, 4 仅退款, 5 重新检查， 6 补发
     * @type {number}
     * @memberof StockErrorGoodsProcessVo
     */
    processMethod?: number;
    /**
     * 退货收件人姓名  申请退货用
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    receiverName?: string;
    /**
     * 退货收件人地址  申请退货用
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    receiverAddress?: string;
    /**
     * 退货收件人电话  申请退货用
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    receiverMobileNo?: string;
    /**
     * 退货收件人邮编  申请退货用
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    receiverZip?: string;
    /**
     * 退货收件人详细地址  申请退货用
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    receiverAddressDetail?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof StockErrorGoodsProcessVo
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof StockErrorGoodsProcessVo
     */
    returnFetchGoodsDate?: string;
}

/**
 * Check if a given object implements the StockErrorGoodsProcessVo interface.
 */
export function instanceOfStockErrorGoodsProcessVo(value: object): value is StockErrorGoodsProcessVo {
    return true;
}

export function StockErrorGoodsProcessVoFromJSON(json: any): StockErrorGoodsProcessVo {
    return StockErrorGoodsProcessVoFromJSONTyped(json, false);
}

export function StockErrorGoodsProcessVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockErrorGoodsProcessVo {
    if (json == null) {
        return json;
    }
    return {
        
        'checkOrderIds': json['checkOrderIds'] == null ? undefined : json['checkOrderIds'],
        'processGroup': json['processGroup'] == null ? undefined : json['processGroup'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'receiverAddress': json['receiverAddress'] == null ? undefined : json['receiverAddress'],
        'receiverMobileNo': json['receiverMobileNo'] == null ? undefined : json['receiverMobileNo'],
        'receiverZip': json['receiverZip'] == null ? undefined : json['receiverZip'],
        'receiverAddressDetail': json['receiverAddressDetail'] == null ? undefined : json['receiverAddressDetail'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
    };
}

export function StockErrorGoodsProcessVoToJSON(json: any): StockErrorGoodsProcessVo {
    return StockErrorGoodsProcessVoToJSONTyped(json, false);
}

export function StockErrorGoodsProcessVoToJSONTyped(value?: StockErrorGoodsProcessVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkOrderIds': value['checkOrderIds'],
        'processGroup': value['processGroup'],
        'processMethod': value['processMethod'],
        'receiverName': value['receiverName'],
        'receiverAddress': value['receiverAddress'],
        'receiverMobileNo': value['receiverMobileNo'],
        'receiverZip': value['receiverZip'],
        'receiverAddressDetail': value['receiverAddressDetail'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
    };
}

